import React, { useEffect, useState } from 'react';
import { Box, Text, Flex, Link, Image } from '@chakra-ui/react';
import { FaInstagram, FaFacebook, FaChevronDown } from 'react-icons/fa';
import { IconWrapper } from './IconWrapper';
import { HERO_SLIDES } from '../data/photos';
import { getNavLinks } from '../data/navigation';
import './Hero.css';

// Fotky v úvodní rotaci jsou vždycky černobílé, i ve světlém režimu.
// Mění se v scripts/build-photos.mjs (konstanta HERO), ne tady.

// Jak dlouho je jedna fotka vidět (ms)
const SLIDE_DURATION = 6000;

const Hero: React.FC = () => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    if (HERO_SLIDES.length < 2) return;

    // Respektuje systémové nastavení "omezit pohyb" – tam zůstane jen první fotka
    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
    if (prefersReducedMotion) return;

    const timer = setInterval(() => {
      setActiveSlide((current) => (current + 1) % HERO_SLIDES.length);
    }, SLIDE_DURATION);

    return () => clearInterval(timer);
  }, []);

  // Následující fotka se stáhne až v průběhu té současné – načtení webu tak
  // nebrzdí fotky, na které ještě nedošlo.
  useEffect(() => {
    const next = HERO_SLIDES[(activeSlide + 1) % HERO_SLIDES.length];
    if (!next) return;
    const onMobile = window.matchMedia('(max-width: 768px)').matches;
    const img = new window.Image();
    img.src = onMobile ? next.mobile : next.src;
  }, [activeSlide]);

  return (
    <Box
      id="hero"
      as="section"
      className="hero-container"
    >
      {HERO_SLIDES.map((slide, index) => (
        <Box
          key={slide.src}
          className={`hero-slide${index === activeSlide ? ' hero-slide--active' : ''}`}
          style={{
            // Kterou z variant vzít, rozhoduje médiový dotaz v Hero.css
            ['--hero-photo' as string]: `url('${slide.src}')`,
            ['--hero-photo-mobile' as string]: `url('${slide.mobile}')`,
            backgroundPosition: slide.position,
          }}
          aria-hidden="true"
        />
      ))}

      <Box className="hero-content">
        <Image
          src="/photos/whiteLogo.png"
          alt="Logo"
          width="600px"
          height="auto"
          mx="auto"
          mb={8}
          className="hero-logo"
        />
        <Text 
          fontSize="lg" 
          mb={8} 
          className="hero-text"
          color="white"
        >
          Profesionální fotografka se zaměřením na portrétní, svatební a rodinnou fotografii.
        </Text>
        <Flex className="nav-links">
          {/* Stejné odkazy jako v menu – mění se v src/data/navigation.ts */}
          {getNavLinks().map((link) => (
            <Link key={link.href} href={link.href} className="nav-link">
              {link.label}
            </Link>
          ))}
        </Flex>

        <Flex className="social-icons">
          <Link href="https://www.instagram.com/hrachovenachova/" isExternal className="social-icon">
            <IconWrapper icon={FaInstagram} />
          </Link>
          <Link href="https://www.facebook.com/hrachovenachova/" isExternal className="social-icon">
            <IconWrapper icon={FaFacebook} />
          </Link>
        </Flex>
      </Box>
      
      <Box className="scroll-indicator" onClick={() => window.scrollTo({
        top: window.innerHeight,
        behavior: 'smooth'
      })}>
        <IconWrapper icon={FaChevronDown} />
      </Box>
    </Box>
  );
};

export default Hero;
